// extracted by mini-css-extract-plugin
export default {"arrowRight":"sGzJQc8BUUGX6hd_yK6Z","pagination":"E95TVwoaB7o01eHQx0Q0","paginationButtons":"Ir1uoKdMe6P45RTYuQaI","list":"brxzvvVEHy7sovSwNGiR","item":"D62YD7IhLopcbtgSjmmg"};